import useAuth from 'src/hooks/useAuth';

import { TAX_PROFILE_COUNTRY_NAME } from './taxProfileHelpers';

// Fiscal data only applies to organizations in El Salvador, where electronic
// invoicing requires it.
export const useTaxProfileAvailable = (): boolean => {
  const { user } = useAuth();

  return user?.current_organization?.country?.name === TAX_PROFILE_COUNTRY_NAME;
};
